// extracted by mini-css-extract-plugin
export var areaTitle = "portfolio-module--area-title--0f915";